export default __webpack_public_path__ + "images/product--narcotic.svg?6f522bceb4910f6642db24d39a09320f";